import { Pipe, PipeTransform } from '@angular/core';
import * as jalalimoment from "jalali-moment";
@Pipe({
  name: 'remianingTime'
})
export class RemianingTimePipe implements PipeTransform {

  transform(value: Date): string {
    if (!value) return "نامعلوم";

    const now = jalalimoment();
    const targetDate = jalalimoment(value);

    // اگر تاریخ گذشته باشد
    if (targetDate.isBefore(now)) {
      return "منقضی شده";
    }

    // محاسبه تفاوت به زبان فارسی
    // برای "۲ روز مانده" از ترکیب توابع خود مومنت استفاده می‌کنیم
    return targetDate.locale('fa').from(now, true);
  }

}
